module.exports = __webpack_public_path__ + "img/gh.d3fe04e3.svg";